<p-divider>
    <div class="d-flex">
        <fa-icon [icon]='["far","user-tie"]'></fa-icon>
        <div class="mx-2">Owner #{{contactIdx+1}}</div>
    </div>
</p-divider>
<div class="d-flex flex-wrap">
    <div class="mt-2 mx-2">
        <mat-form-field class="">
            <mat-label>First Name</mat-label>
            <input matInput (change)="inputAction($event)" #owner{{contactIdx+1}}firstName type="text" [formControl]="contactFirstNameControl"
                name="owner{{contactIdx+1}}firstName" [(ngModel)]="contact.firstName" />
        </mat-form-field>
    </div>
    <div class="mt-2 mx-2">
        <mat-form-field class="">
            <mat-label> Middle Initial</mat-label>
            <input matInput (change)="inputAction($event)" #owner{{contactIdx+1}}middleInitial type="text" 
                name="owner{{contactIdx+1}}middleInitial" [(ngModel)]="contact.middleInitial" />
        </mat-form-field>
    </div>
    <div class="mt-2 mx-2">
        <mat-form-field class="">
            <mat-label>Last Name</mat-label>
            <input matInput (change)="inputAction($event)" #owner{{contactIdx+1}}lastName type="text" [formControl]="contactLastNameControl"
                name="owner{{contactIdx+1}}lastName" [(ngModel)]="contact.lastName" />
        </mat-form-field>
    </div>
    <div class="mt-2 mx-2">
        <mat-form-field class="">
            <mat-label>Title</mat-label>
            <mat-select #owner{{contactIdx}}Title  [(ngModel)]="contact.title" [formControl]="contactTitleControl" (valueChange)="inputAction($event)">
                <mat-option *ngFor="let value of contactTitles" [value]="value.value">
                    {{value.label}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="mt-2 mx-2">
        <mat-checkbox class="mx-2" name="owner{{contactIdx+1}}isPos" [(ngModel)]="contact.isPoc" (change)="contactPocChange()">
            Main point of contact
        </mat-checkbox>
    </div>

</div>
<div class="d-flex flex-wrap">
    <div class="mt-2 mx-2">
        <mat-form-field class="">
            <mat-label>Ownership %</mat-label>
            <mat-icon matSuffix>
                <fa-icon [icon]='["far","percentage"]'></fa-icon>
            </mat-icon>
            <input matInput (change)="inputAction($event)" #owner{{contactIdx}}ownershipPercentage type="number" [formControl]="contactOwnershipPercentageControl"
                name="owner{{contactIdx}}ownershipPercentage" [(ngModel)]="contact.ownershipPercentage" />
                <mat-error *ngIf="contactOwnershipPercentageControl.errors">
                    <div *ngIf="contactOwnershipPercentageControl.hasError('required')">Ownership percentage is required.</div>
                    <div *ngIf="contactOwnershipPercentageControl.hasError('min')">Please list owners with 20% or more ownership.</div>
                    <div *ngIf="contactOwnershipPercentageControl.hasError('max')">Ownership cannot be more than 100%</div>
                </mat-error>
        </mat-form-field>
    </div>
    <div class="mt-2 mx-2">
        <mat-form-field class="">
            <mat-label>Date of Birth</mat-label>
            <input matInput (change)="inputAction($event)" #owner{{contactIdx}}dob [matDatepicker]="picker" [formControl]="contactDateOfBirthControl"
                name="owner{{contactIdx}}dob" [(ngModel)]="contact.dateOfBirth">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
    </div>
    <div class="mt-2 mx-2">
        <mat-form-field class="">
            <mat-label>SSN</mat-label>
            <input matInput (change)="inputAction($event)" #owner{{contactIdx}}ssn type="text" name="owner{{contactIdx}}ssn" [formControl]="contactSocialSecurityNumberControl"
                [(ngModel)]="contact.socialSecurityNumber" placeholder="e.g. 111-22-3333"
                [textMask]="{mask: app.references.ssnMask}" />
        </mat-form-field>
    </div>
    <p-button pRipple styleClass="p-button-raised p-button-danger m-2" (click)="removeContactEmitter.emit(contactIdx)">
        <ng-template pTemplate="content">
            <div class="d-flex justify-content-center">
                <fa-icon [icon]='["far","user-minus"]' size="lg" class="ms-1 me-2"></fa-icon>
                Remove Owner
            </div>
        </ng-template>
    </p-button>
</div>